import * as React from 'react';

import { renderJsxOrParagraphTag } from '../../utilities';
import Button from '../utils/Button';
import ButtonIcon from '../utils/ButtonIcon';

export default function HeroSimpleTextLeft(props) {
  const { title, subtitle, description, links, colorTheme } = props;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      {subtitle && (
        <p
          className={`text-lg font-semibold uppercase ${
            colorTheme === 'black' || colorTheme === 'white'
              ? 'text-neutral'
              : ''
          }`}
        >
          {subtitle}
        </p>
      )}
      <h1
        className={`text-4xl font-extrabold sm:text-5xl lg:text-6xl ${
          colorTheme === 'black'
            ? 'text-base-content'
            : colorTheme === 'white'
              ? 'text-white'
              : ''
        }`}
      >
        {title}
      </h1>
      {description && (
        <div className="mt-6 text-lg max-w-3xl text-neutral sm:text-xl">
          {renderJsxOrParagraphTag(description)}
        </div>
      )}
      {links && (
        <div className="space-y-6 mt-8 sm:flex sm:space-x-8 sm:space-y-0 sm:max-w-none">
          {links.map(link => (
            <Button
              key={link.id}
              color={link.color}
              internalLinkTo={link.url}
              fullWidth="mobile"
              size="xxl"
            >
              <ButtonIcon icon={link.icon} position="leading" size="xxl" />
              {link.text}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
